/**
 * Standard form placeholders — generic labels (no sample emails, numbers, or “e.g.” values).
 * Use across storefront, checkout, mobile, and admin for consistent UX.
 */
export const PH = {
  fullName: 'Full name',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email address',
  phone: 'Phone number',
  /** Local number when country code is selected separately */
  phoneLocal: 'Phone number',
  searchCountries: 'Search countries',
  password: 'Password',
  newPassword: 'New password',
  confirmPassword: 'Confirm password',
  currentPassword: 'Current password',
  streetAddress: 'Street address',
  aptOptional: 'Apartment, suite, unit (optional)',
  city: 'City',
  state: 'State or province',
  zip: 'ZIP or postal code',
  country: 'Country',
  cardNumber: 'Card number',
  nameOnCard: 'Name on card',
  cardExpiry: 'Expiry date',
  cvv: 'Security code',
  promoCode: 'Promo code',
  giftMessage: 'Gift message (optional)',
  message: 'Message',
  subject: 'Subject',
  postalCode: 'Postal code',
  reviewTitle: 'Review title',
  reviewBody: 'Your review',
  upiId: 'UPI ID',
  min: 'Minimum',
  max: 'Maximum',
  searchProducts: 'Search products',
  /** Hero / global catalog search */
  searchCatalog: 'Search products, brands, or categories',
  searchTickets: 'Search tickets',
  searchHelp: 'Search help',
  searchLanguages: 'Search languages',
  notesOptional: 'Notes (optional)',
  description: 'Description',
  deliveryArea: 'Area, street, or landmark',
  /** Masked password fields */
  passwordMasked: 'Password',
  /** Admin list filters */
  adminSearchCustomers: 'Search customers',
  adminSearchVendors: 'Search vendors',
  adminSearchOrders: 'Search orders',
  adminSearchReviews: 'Search reviews',
  /** Admin / CMS media */
  imageUrl: 'Image URL',
  vendorBio: 'Vendor description',
  legalBusinessName: 'Legal business name',
  storeDisplayName: 'Store name',
  websiteUrl: 'Website URL',
  taxId: 'Tax ID',
  bankName: 'Bank name',
  accountHolderName: 'Account holder name',
  accountNumber: 'Account number',
  /** Prices / percents */
  priceZero: 'Amount',
  percentExample: 'Percentage',
  optional: 'Optional',
  unlimited: 'Unlimited',
  stripePublishableKey: 'Publishable key',
  stripeSecretKey: 'Secret key',
  ellipsis: '—',

  /** Admin — promotions */
  promotionName: 'Promotion name',
  discountCode: 'Discount code',
  discountValue: 'Discount value',

  /** Admin — products */
  productName: 'Product name',
  productSku: 'SKU',
  productDescription: 'Product description',
  subcategory: 'Subcategory',
  colorName: 'Color name',
  material: 'Material',
  careInstructions: 'Care instructions',
  productDetailsLines: 'One detail per line',

  /** Admin — videos & content */
  videoTitle: 'Video title',
  videoUrl: 'Video URL',
  thumbnailUrl: 'Thumbnail URL',
  heroImageUrl: 'Hero image URL',
  ogImageUrl: 'Social preview image URL',

  /** Admin — categories & badges */
  categoryName: 'Category name',
  urlSlug: 'URL slug',
  categoryDescription: 'Category description',
  badgeInternalName: 'Internal name',
  badgeDisplayLabel: 'Display label',
  badgeUsageDescription: 'When to use this badge',

  /** Admin — subscriptions */
  planConfigCode: 'Plan code',
  planName: 'Plan name',
  storageLimit: 'Storage limit',
  bandwidthLimit: 'Bandwidth limit',
  displayOrder: 'Display order',

  /** Admin — site / integrations */
  tagline: 'Tagline',
  socialInstagram: 'Instagram',
  socialFacebook: 'Facebook URL',
  socialTwitter: 'Twitter',
  socialPinterest: 'Pinterest URL',
  socialYoutube: 'YouTube URL',
  ipAllowlist: 'IP addresses (comma-separated)',
  customFontUrl: 'Font stylesheet URL',
  smtpHost: 'SMTP host',
  smtpPort: 'Port',
  smtpUsername: 'SMTP username',
  twilioAccountSid: 'Account SID',
  measurementId: 'Measurement ID',
  facebookPixelId: 'Pixel ID',
  gtmContainerId: 'Tag Manager container ID',
  tiktokPixelId: 'TikTok pixel ID',
  pinterestTagId: 'Pinterest tag ID',
  hotjarSiteId: 'Hotjar site ID',
  customHeaderScripts: 'Custom scripts',
} as const;
